/**
 * JWT Service Interface
 * Defines the structure of the JWT service
 */
interface IJwtService {
    getToken(): string | null;
    saveToken(token: string): void;
    destroyToken(): void;
    hasToken(): boolean;
  }
  
  /**
   * JWT Service
   * Handles token management for authentication
   */
  const JwtService: IJwtService = {
    /**
     * Get the JWT token from localStorage
     * @returns The stored JWT token or null if not found
     */
    getToken(): string | null {
      return localStorage.getItem("token");
    },
  
    /**
     * Save the JWT token to localStorage
     * @param token - The JWT token to save
     */
    saveToken(token: string): void {
      localStorage.setItem("token", token);
    },
  
    /**
     * Remove the JWT token from localStorage
     */
    destroyToken(): void {
      localStorage.removeItem("token");
    },
  
    /**
     * Check if a token exists
     * @returns True if token exists, false otherwise
     */
    hasToken(): boolean {
      return !!this.getToken();
    }
  };
  
  export default JwtService;